import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { LayoutWithUserNav } from '@members/layout/containers';

const Overview = dynamic(() => import('@members/pg-overview/Overview'), {
  ssr: false,
});

export default function MemberProfileOverviewBasePage() {
  const router = useRouter();
  useEffect(() => {
    router.replace(`${router.asPath}/overview`);
  }, []);

  return (
    <LayoutWithUserNav memberId={router.query.memberId as string}>
      <Overview />
    </LayoutWithUserNav>
  );
}
